export default __webpack_public_path__ + "media/images/new_year/header_1920x1080-e23fd7cbda8cd8378c5d006d147adad9.jpg";